export class RunAgentRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "appName",
            "baseName": "app_name",
            "type": "AiAgentAppName",
            "format": ""
        },
        {
            "name": "userId",
            "baseName": "user_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "sessionId",
            "baseName": "session_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "newMessage",
            "baseName": "new_message",
            "type": "{ [key: string]: any; }",
            "format": ""
        },
        {
            "name": "streaming",
            "baseName": "streaming",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "stateDelta",
            "baseName": "state_delta",
            "type": "{ [key: string]: any; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RunAgentRequest.attributeTypeMap;
    }
    constructor() {
    }
}
